// Eswatini VAT rate. Auto VAT = VAT_RATE × the total of the order items the admin
// flagged with "Charge VAT?" (should_charge_vat). Mirrors Order::VAT_RATE on the backend,
// which recomputes authoritatively on save — this is the live preview in the form.
export const VAT_RATE = 0.15;

type VatItem = {
  unit_price: number | string;
  quantity: number | string;
  should_charge_vat?: boolean | null;
};

export function calculateAutoVat(items: VatItem[]): number {
  const base = items
    .filter((item) => item.should_charge_vat)
    .reduce((sum, item) => sum + Number(item.unit_price || 0) * Number(item.quantity || 0), 0);
  return Math.round(base * VAT_RATE * 100) / 100;
}
